import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import drawerBarStyles from '@/common/components/NavigationBar/DrawerBar.styles';
import logo from '@/common/assets/logo.svg';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/app/providers/AuthProvider';
import { MARKETING_SITE_URL } from '@/app/config';

const Header = ({ mobile = false, admin = false, onMenuClick }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const firstDecedent = user?.decedents?.[0];
  const decedentName = firstDecedent
    ? `${firstDecedent.firstName} ${firstDecedent.lastName}`
    : '';

  if (mobile) {
    return (
      <AppBar position="static" color="inherit" elevation={0}>
        <Toolbar sx={drawerBarStyles.mobileHeaderToolbar}>
          <IconButton edge="start" onClick={onMenuClick}>
            <MenuIcon sx={{ fontSize: 36 }} />
          </IconButton>
          <Box component="a" href={MARKETING_SITE_URL} display="inline-flex">
            <Box
              component="img"
              src={logo}
              alt="Praedias logo"
              sx={{ height: '38px' }}
            />
          </Box>
        </Toolbar>
      </AppBar>
    );
  }

  return (
    <Box display="flex" flexDirection="column">
      <Box width="100%" px={6} py={3}>
        <Box component="a" href={MARKETING_SITE_URL} display="inline-flex">
          <Box
            component="img"
            sx={drawerBarStyles.navigationLogo}
            src={logo}
            alt="Praedias logo"
          />
        </Box>
      </Box>
      {!admin && decedentName && (
        <Box borderBottom="1px solid" borderColor="divider">
          <Box
            sx={{
              display: 'inline-flex',
              width: '100%',
              gap: 1,
              alignItems: 'center',
              px: 4,
              py: 2,
              mx: 2,
              mb: 2,
            }}
          >
            <Typography variant="body2" color="text.tertiary">
              {t('For')}
            </Typography>
            <Typography variant="subtitle1">{decedentName}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Header;
